import CalendarIcon from "assets/images/Calendar";
import ClockIcon from "assets/images/Clock";
import classNames from "classnames";
import {format} from "date-fns";
import {appointmentConfirmationModal as strings} from "strings";

import Button from "components/Button";
import Divider from "components/Divider";
import PageTitle from "components/PageTitle";
import StyledModal from "components/StyledModal";

import styles from "./AppointmentConfirmationModal.module.css";

type Props = {
  visible: boolean;
  onClickClose: () => void;
  startDateTime: string;
  succeessMessage: string;
};

export default function AppointmentConfirmationModal(props: Props) {
  return (
    <StyledModal visible={props.visible} className={styles.styledModal}>
      <div className={styles.modalContent}>
        <PageTitle className={styles.pageTitle}>{strings.title}</PageTitle>
        <div className={styles.description}>{props.succeessMessage}</div>
        <Divider className={styles.divider} />
        <div className={styles.row}>
          <div className={styles.padding}>
            <CalendarIcon />
          </div>
          <p className={classNames(styles.bold16, styles.label)}>
            {strings.date}
          </p>
          <p className={styles.regular16}>
            {props.startDateTime &&
              format(new Date(props.startDateTime), "MM/dd/yy")}
          </p>
        </div>
        <Divider className={styles.divider} />
        <div className={styles.row}>
          <div className={styles.padding}>
            <ClockIcon />
          </div>
          <p className={classNames(styles.bold16, styles.label)}>
            {strings.time}
          </p>
          <p className={styles.regular16}>
            {props.startDateTime &&
              format(new Date(props.startDateTime), "hh:mm aaa")}
          </p>
        </div>
        <Divider className={styles.divider} />
        <Button className={styles.continueButton} onClick={props.onClickClose}>
          {strings.continue}
        </Button>
      </div>
    </StyledModal>
  );
}
